import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { PoweredByLink } from '../PoweredByLink';
import { FooterSharedStyles, FooterWedge } from './FooterSharedStyles';
export const FooterWithCenteredLogo = () => {
    return (_jsxs(FooterWithCenteredLogoRoot, { children: [_jsx(PoweredByLink, {}), _jsx(FooterWedge, {})] }));
};
const FooterWithCenteredLogoRoot = styled.div `
    ${FooterSharedStyles}
    align-items: center;
    display: flex;
    justify-content: center;
`;
